import { Button, Sheet } from "@xinghai/ui";
import { Illustration } from "../shared/Illustration";
import type { IllustrationName } from "../shared/Illustration";

const KEY = "xz.tips_seen";

/** Shown once per device, before the very first recording. */
export function tipsSeen(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function markTipsSeen(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Test helper / 「再看一遍小贴士」. */
export function clearTipsSeen(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

const TIPS: ReadonlyArray<{ name: IllustrationName; text: string }> = [
  { name: "guide-distance", text: "离嘴一个手掌" },
  { name: "guide-volume", text: "平常说话的音量" },
  { name: "guide-quiet", text: "周围安静" },
];

export interface RecordingTipsSheetProps {
  open: boolean;
  onClose: () => void;
}

/** 录音小贴士 — three things that decide whether a take is usable. */
export function RecordingTipsSheet({ open, onClose }: RecordingTipsSheetProps) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title="录音小贴士"
      size="md"
      footer={
        <Button variant="primary" size="lg" block onClick={onClose}>
          知道了，开始录
        </Button>
      }
    >
      <p className="gz-muted">记住这三件事，录出来的声音就够用了。</p>
      <div className="xz-tips">
        {TIPS.map((t) => (
          <div className="xz-tips__row" key={t.name}>
            <Illustration name={t.name} size="sm" />
            <span className="xz-tips__text">{t.text}</span>
          </div>
        ))}
      </div>
    </Sheet>
  );
}
